// removed by extract-text-webpack-plugin
module.exports = {"promoWrap":"_3M8NqQp4iIqCBxjnex595K","title":"_1fpwkIMqDCw57_QavSX-rZ","promoBlock":"_3I9IQgaAz9KGK6S5_sIwwb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PromoBlock/promoBlock.scss
// module id = 1709
// module chunks = 0